import { ENVIRONMENT } from "../config";
import { isNullOrUndefined, safe } from "../utils";
import { ISearchEntityResponse, IDataEntityResponse, IDataEntity, IAppParams } from "../models";

export function generateRequest(method: "POST" | "GET", body?: {}): {} {
    let fetchObj = {
        method: method,
    };

    Object.assign(fetchObj, {
        body: JSON.stringify(body),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "X-KSYS-TOKEN": ENVIRONMENT.token
        },
    });

    return fetchObj;
}

export function orchestrateBasicSearchResponse(searchResponseData: ISearchEntityResponse): IDataEntityResponse {
    let response = <IDataEntityResponse>{
        limit: searchResponseData.limit,
        total: searchResponseData.total,
        values: <IDataEntity[]>[]
    };

    for (let value of searchResponseData.values) {
        let dataEntity = <IDataEntity>Object.assign({}, value);
        dataEntity.properties = Object.keys(value.properties_pub).reduce((existing, current) => {
            if (value && value.properties_pub && value.properties_pub[current] && !isNullOrUndefined(value.properties_pub[current].value)) {
                existing[current] = value.properties_pub[current].value;
            }
            for (let key of Object.keys(value.properties_pub[current]).filter(key => key !== 'value')) {
                existing[`${current}_${key}`] = value.properties_pub[current][key];
            }
            return existing;
        }, {});
        delete dataEntity['properties_pub'];
        response.values.push(dataEntity);
    }

    return response;
}

export function orchestrateBenchmarkResponse(benchmarkResponseData: IDataEntityResponse): IDataEntityResponse {
    let response = <IDataEntityResponse>{
        limit: benchmarkResponseData.limit,
        total: benchmarkResponseData.total,
        values: <IDataEntity[]>[]
    };

    for (let value of benchmarkResponseData.values) {
        let dataEntity = <IDataEntity>Object.assign({}, value);
        dataEntity.properties = Object.keys(value["properties_pub"]).reduce((existing, current) => {
            if (value && value["properties_pub"] && value["properties_pub"][current] && !isNullOrUndefined(value["properties_pub"][current].value)) {
                existing[current] = value["properties_pub"][current].value;
            }
            for (let key of Object.keys(value["properties_pub"][current]).filter(key => key !== 'value')) {
                existing[`${current}_${key}`] = value["properties_pub"][current][key];
            }
            return existing;
        }, {});
        delete dataEntity['properties_pub'];
        response.values.push(dataEntity);
    }

    return response;
}

export function getGroupedRows(funds: IDataEntityResponse) {
    let response = [];
    if (funds) {
        for (let fund of funds.values) {
            let groupBase = {
                key: fund.clientCode,
                display: fund.properties['fund_name'],
                collapsed: !!fund.collapsed,
                fund,
                rows: []
            }
            for (let shareClass of fund.shareClasses) {

                let chargesTimeseries = safe(() => shareClass.timeseries.filter(t => t.code === 'charges')[0], { values: [] });
                let chargesValues = safe(() => {
                    let values = [].concat(chargesTimeseries.values);

                    values.sort((a, b) => {
                        let aDate = new Date(a).getTime();
                        let bDate = new Date(b).getTime();
                        return aDate - bDate;
                    });
                    return values[0];
                }, {});


                groupBase.rows.push(Object.assign({ fund, key: shareClass.clientCode, chargesValues, chargesTimeseries }, shareClass));
            }
            response.push(groupBase);
        }
    }
    return response;
}

export function isPrint(appParams: IAppParams) {
    if (appParams) {
        return appParams.isprint === 'true';
    }

    return false;
}

export function parseToRoundedDecimal(value, decimalPlaces: number = 2) {
    if (!isNullOrUndefined(value)) {
        value = parseFloat(value);
        if (value % 1 !== 0) {
            return parseFloat(value.toFixed(decimalPlaces));
        }
        return parseFloat(value);
    } else {
        return value;
    }
}

export function generateRandomKey(text: string, length: number = 5) {
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++){
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}


// WEBPACK FOOTER //
// ./src/client/utils/data.ts